var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgProducts = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9998 12.719L12.7212 20L6.17578 13.454L7.29624 7.29227L13.4552 6.17224L19.9998 12.719Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66549 8.96505C6.38438 8.74802 6.07081 8.40979 5.79683 8.13651C4.29154 6.63073 3.59551 4.88731 4.24086 4.24095C4.887 3.59539 6.63065 4.29164 8.13515 5.79664C10.5717 8.23394 10.8979 9.60824 10.2502 10.2522",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProducts, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/products.629fdd1f.svg";
export { ForwardRef as ReactComponent };